import { HidService } from "src/app/services/common/hid.service";
import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
@Injectable({
  providedIn: "root"
})
export class menuGuard implements CanActivate {
  constructor(private router: Router, private hidService: HidService) {}
  canActivate() {
    if (localStorage.getItem("menu") || this.hidService.getHID()) {
      return true;
    }
    this.router.navigate(["/"]);
  }
}
